import { updateDocument } from '../services/documents';

export interface QrCodeStartTransactionParams {
  chargeBoxId: string;
  connectorId: number;
  token: string;
  recaptchaResponse: string;
}

export const setQrCodeStartTransaction = async (params: QrCodeStartTransactionParams): Promise<any> => {
  const data = await updateDocument('start', params, 'qrcode');
  return data;
};

export interface QrCodeStopTransactionParams {
  chargeBoxId: string;
  connectorId: number;
  token: string;
}

export const setQrCodeStopTransaction = async (params: QrCodeStopTransactionParams): Promise<any> => {
  const data = await updateDocument('stop', params, 'qrcode');
  return data;
};
